"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzButton = exports.AnimationLoading = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-identical-expressions */
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const className_1 = require("../../utils/className");
exports.AnimationLoading = () => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("span", null, "\u2022"),
        react_1.default.createElement("span", null, "\u2022"),
        react_1.default.createElement("span", null, "\u2022")));
};
exports.VbzButton = (_a) => {
    var { id, type = 'button', color = 'primary', style, dark = false, isLoading = false, animation = true, text = '', loadingText = 'Carregando...', block = false, className = '', icon, disabled = false, onClick, onMouseDown } = _a, params = __rest(_a, ["id", "type", "color", "style", "dark", "isLoading", "animation", "text", "loadingText", "block", "className", "icon", "disabled", "onClick", "onMouseDown"]);
    return (react_1.default.createElement(reactstrap_1.Button, Object.assign({ id: id, type: type, style: style, isLoading: isLoading, text: text, color: color, block: block, className: className_1.mapToCssModules([
            className,
            color === 'hyperlink' ? 'hyperlink' : '',
            !text && icon ? 'btn-icon' : '',
            dark ? 'dark' : '',
            isLoading ? 'vbz-btn-loading' : '',
            animation ? 'animation' : '',
        ]), disabled: disabled, onClick: (event) => {
            if (!isLoading && onClick) {
                onClick(event);
            }
        }, onMouseDown: (event) => {
            if (!isLoading && onMouseDown) {
                onMouseDown(event);
            }
        } }, params), color !== 'hyperlink' ? (react_1.default.createElement("span", { tabIndex: -1 },
        isLoading && animation && react_1.default.createElement(exports.AnimationLoading, null),
        isLoading && !animation && loadingText,
        !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
            icon && icon,
            text)))) : (react_1.default.createElement("div", { tabIndex: -1 },
        icon && icon,
        text))));
};
//# sourceMappingURL=index.js.map